module.exports = __webpack_public_path__ + "static/media/spinner.6c146357.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spinner.svg
// module id = 606
// module chunks = 0